// MSAL imports
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import {
    QueryClient,
    QueryClientProvider,
} from "@tanstack/react-query";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faBars,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircleNotch,
    faExclamationTriangle,
    faEye,
    faFilter,
    faInfoCircle,
    faLemon,
    faPencil,
    faPlus,
    faRedo,
    faThumbsDown,
    faThumbsUp,
    faTimes,
    faTrash,
    faVideo,
} from "@fortawesome/pro-regular-svg-icons";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LocalHistoryProvider } from "../context/LocalHistory";
import { ConnectivityProvider } from "../offline/connectivityMonitor";
import { DebugTargetsProvider } from "../utils/useDebugTargets";
import MainContent from "./MainContent";

library.add(
    faChevronRight,
    faPlus,
    faInfoCircle,
    faCheck,
    faTimes,
    faChevronUp,
    faChevronDown,
    faChevronLeft,
    faPencil,
    faFilter,
    faEye,
    faTrash,
    faBars,
    faCircleNotch,
    faRedo,
    faVideo,
    faLemon,
    faThumbsDown,
    faThumbsUp,
    faExclamationTriangle
);

// Create a client
const queryClient = new QueryClient();

const App = ({ pca }: { pca: PublicClientApplication }) => {
    // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
    return (
        <MsalProvider instance={pca}>
            <QueryClientProvider client={queryClient}>
                <LocalHistoryProvider>
                    <ConnectivityProvider>
                        <div className="wrapper">
                            <ToastContainer limit={4} />
                            <DebugTargetsProvider>
                                <MainContent />
                            </DebugTargetsProvider>
                        </div>
                    </ConnectivityProvider>
                </LocalHistoryProvider>
            </QueryClientProvider>
        </MsalProvider>
    );
};

export default App;
